import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class ProductSku extends HTMLElement {
  connectedCallback() {
    this.closest('.shopify-section, dialog')?.addEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  disconnectedCallback() {
    this.closest('.shopify-section, dialog')?.removeEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  /** @param {import('@theme/events').VariantUpdateEvent} event */
  updateSku = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const skuBlocks = event.detail.data.html.querySelectorAll('product-sku');
    const newSku = [...skuBlocks].find(
      (skuBlock) => skuBlock instanceof HTMLElement && skuBlock.dataset.blockId === this.dataset.blockId
    );

    if (!(newSku instanceof HTMLElement)) return;

    this.hidden = newSku.hidden;
    morph(this, newSku, { childrenOnly: true });
  };
}

if (!customElements.get('product-sku')) {
  customElements.define('product-sku', ProductSku);
}
